module.exports = __webpack_public_path__ + "img/gift.5e1c2bac.png";